import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Button } from "../UI/Index";
import { ButtonVariantType } from "../UI/Types";
import Tasks from "~icons/emis/tasks";
import "./Style.scss";

interface NotificationProps {
  /**
   * Sucess or Failure message
   */
  message: string;
}

/**
 * Responsible for rendering the Notification banner
 * @returns notification div element
 */
export const NotificationBanner: React.FC<NotificationProps> = (props: NotificationProps) => {

  const { message } = props;
  const [displayMessage, setDisplayMessage] = React.useState<boolean>(false);
  const { t: translate } = useTranslation();

  const onSubmit = (): void => {
    setDisplayMessage(false);
  };

  React.useEffect(() => {
    if(message !== "")
      setDisplayMessage(true);
    else
      setDisplayMessage(false);
  },[message]);

  return (
    <>
      {
        displayMessage && (
          <div className="notification-banner">
            <div className="notification-banner__container">
              <div className="notification-banner__container-message">
                <Tasks title="" className="notification-banner-taskicon"/>
                <span>{message}</span>
              </div>
              <Button
                variant={ButtonVariantType.MONO}
                type="button"
                onClick={onSubmit}
              >
                {translate("Button.Dismiss")}
              </Button>
            </div>
          </div>
        )
      }
    </>
  );
};
